import React, { useState, useEffect } from 'react';
import api from '../../utils/api';
import toast from 'react-hot-toast';
import { Youtube, Check, X, Trash2, Clock, Loader, ExternalLink } from 'lucide-react';

export default function AdminOACPage() {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => { try { const { data } = await api.get('/oac'); setRequests(data.requests || []); } catch (e) {} finally { setLoading(false); } };
  useEffect(() => { load(); }, []);

  const update = async (id, status, notes) => {
    try { await api.put(`/oac/${id}`, { status, admin_notes: notes }); toast.success('Aggiornato'); load(); }
    catch (err) { toast.error('Errore'); }
  };

  const del = async (id) => {
    if (!window.confirm('Eliminare questa richiesta OAC?')) return;
    try { await api.delete(`/oac/${id}`); toast.success('Eliminata'); load(); }
    catch (err) { toast.error('Errore'); }
  };

  const statusColors = { submitted: 'bg-yellow-600', in_review: 'bg-blue-600', approved: 'bg-green-600', rejected: 'bg-red-600' };
  const statusLabels = { submitted: 'Inviata', in_review: 'In Revisione', approved: 'Approvata', rejected: 'Rifiutata' };

  if (loading) return <div className="flex justify-center py-16"><Loader size={24} className="animate-spin text-yellow-400" /></div>;

  return (
    <div>
      <h1 className="text-2xl font-bold text-white mb-6">Richieste OAC ({requests.length})</h1>
      {requests.length === 0 ? <div className="card-dark p-12 text-center text-gray-500">Nessuna richiesta</div> : (
        <div className="space-y-4">{requests.map(r => (
          <div key={r.id} className="card-dark p-5">
            <div className="flex items-center gap-4 mb-3">
              <Youtube size={24} className="text-red-500 flex-shrink-0" />
              <div className="flex-1">
                <p className="font-bold text-white text-lg">{r.artist_name}</p>
                <p className="text-xs text-gray-400">{r.first_name} {r.last_name} ({r.email}) · {new Date(r.submitted_at).toLocaleDateString('it-IT')}</p>
              </div>
              <span className={`text-[10px] px-2.5 py-1 rounded-full text-white ${statusColors[r.status]}`}>{statusLabels[r.status]}</span>
            </div>
            <div className="grid grid-cols-2 gap-3 text-xs mb-3 bg-gray-900 rounded-lg p-3">
              <div><span className="text-gray-500">Topic Channel:</span><br/><a href={r.topic_channel_url} target="_blank" rel="noreferrer" className="text-blue-400 hover:underline flex items-center gap-1">{r.topic_channel_url?.substring(0,50)}... <ExternalLink size={10} /></a></div>
              <div><span className="text-gray-500">YouTube Channel:</span><br/><a href={r.youtube_channel_url} target="_blank" rel="noreferrer" className="text-blue-400 hover:underline flex items-center gap-1">{r.youtube_channel_url?.substring(0,50)}... <ExternalLink size={10} /></a></div>
            </div>
            {r.notes && <p className="text-xs text-gray-400 mb-3 bg-gray-900 rounded-lg p-3">Note utente: {r.notes}</p>}
            <div className="flex gap-2 justify-end">
              {r.status !== 'approved' && <button onClick={() => update(r.id, 'approved', null)} className="px-3 py-1.5 bg-green-600 text-white text-xs rounded-lg hover:bg-green-700 flex items-center gap-1"><Check size={12} />Approva</button>}
              {r.status !== 'in_review' && r.status !== 'approved' && <button onClick={() => update(r.id, 'in_review', null)} className="px-3 py-1.5 bg-blue-600 text-white text-xs rounded-lg hover:bg-blue-700 flex items-center gap-1"><Clock size={12} />In Revisione</button>}
              {r.status !== 'rejected' && <button onClick={() => { const n = prompt('Motivo rifiuto (opzionale):'); update(r.id, 'rejected', n); }} className="px-3 py-1.5 bg-orange-600 text-white text-xs rounded-lg hover:bg-orange-700 flex items-center gap-1"><X size={12} />Rifiuta</button>}
              <button onClick={() => del(r.id)} className="px-3 py-1.5 bg-red-900/50 text-red-300 text-xs rounded-lg hover:bg-red-900 flex items-center gap-1"><Trash2 size={12} />Elimina</button>
            </div>
          </div>
        ))}</div>
      )}
    </div>
  );
}
